import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-8">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-slate-400 text-sm flex items-center gap-2">
            © {currentYear} Adil - AI Video Creator. Crafted with{' '}
            <Heart className="w-4 h-4 text-emerald-400 fill-emerald-400 animate-pulse" /> using Google Veo 3
          </div>

          <div className="flex items-center gap-6">
            <a
              href="#services"
              className="text-slate-400 hover:text-emerald-400 transition-colors text-sm"
            >
              Services
            </a>
            <a
              href="#portfolio"
              className="text-slate-400 hover:text-emerald-400 transition-colors text-sm"
            >
              Portfolio
            </a>
            <a
              href="#about"
              className="text-slate-400 hover:text-emerald-400 transition-colors text-sm"
            >
              About
            </a>
            <a
              href="#contact"
              className="text-slate-400 hover:text-emerald-400 transition-colors text-sm"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
